import { findDistanceBetweenPoints } from "./findDistanceBetweenPoints"
import type { Edge2dComputed } from "../mesh"

export type EdgePair = { e1: Edge2dComputed; e2: Edge2dComputed }

export const findSegmentsClosestPoints = ({
  e1,
  e2,
}: EdgePair): Edge2dComputed => {
  const { p1: a, p2: b } = e1
  const { p1: c, p2: d } = e2

  const ac = findDistanceBetweenPoints(a, c)
  const ad = findDistanceBetweenPoints(a, d)
  const bc = findDistanceBetweenPoints(b, c)
  const bd = findDistanceBetweenPoints(b, d)

  const min = Math.min(ac, ad, bc, bd)
  switch (min) {
    case ac:
      return { p1: a, p2: c }
    case ad:
      return { p1: a, p2: d }
    case bc:
      return { p1: b, p2: c }
    case bd:
      return { p1: b, p2: d }
    default:
      throw new Error(`Strange minimum distance`)
  }
}
